import { Link } from "react-router-dom";
import type { ContentItem } from "@/types/content";
import { formatDate, typeBadgeClass, typeLabels } from "@/utils/content";

interface ContentCardProps {
  item: ContentItem;
  compact?: boolean;
}

export default function ContentCard({ item, compact = false }: ContentCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer h-full"
    >
      <div className={`relative w-full overflow-hidden bg-background-200 ${compact ? "aspect-[16/9]" : "aspect-[16/10]"}`}>
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 年轻的母亲3`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span
          className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium ${typeBadgeClass[item.type]}`}
        >
          {typeLabels[item.type]}
        </span>
      </div>

      <div className="p-4 md:p-5 flex flex-col flex-1">
        <h3 className={`font-heading font-bold text-foreground-950 line-clamp-2 group-hover:text-primary-700 transition-colors ${compact ? "text-base" : "text-base md:text-lg"}`}>
          {item.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
          {item.summary}
        </p>

        {!compact && item.tags && item.tags.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-1.5">
            {item.tags.slice(0, 3).map((tag) => (
              <span key={tag} className="px-2 py-0.5 rounded bg-background-100 text-secondary-700 text-xs">
                {tag}
              </span>
            ))}
          </div>
        )}

        <div className="mt-4 pt-3 border-t border-background-100 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-calendar-line"></i></span>
            {formatDate(item.date)}
          </span>
          <span className="flex items-center gap-1 text-primary-700 font-medium">
            阅读详情
            <span className="w-3.5 h-3.5 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
              <i className="ri-arrow-right-line"></i>
            </span>
          </span>
        </div>
      </div>
    </Link>
  );
}